<template>
    <div class="container-fluid">
        <div class="row">
            <Card3 colClass="col-sm-12" text="true" headerTitle="true" :title="t('AddEditCategory')">
                <div class="row g-xl-5 g-3">
                    
                <productcategoryadd />
                </div>
            </Card3>
        </div>
    </div>
</template>
<script lang="ts" setup>
import { ref, defineAsyncComponent } from 'vue'

import { useI18n } from 'vue-i18n';
import { productCategoryAddLanguage } from '@/core/locales/product-category-language';

const { t } = useI18n({
    messages: productCategoryAddLanguage
});

const Card3 = defineAsyncComponent(() => import("@/components/common/card/CardData3.vue"))
const productcategoryadd = defineAsyncComponent (() => import ("@/components/theme/ecommerce/productcategory/productcategoryadd.vue"))
</script>